import { Component } from "react";
// import Tabs from "../reuseable/Tabs";
import dict from "../../Data/dict.json";
import PaymentTableKetengan from "./PaymentTableKetengan";
import RedeemButton from "./RedeemButton";
// import BuyNow from "./BuyNow";
import PaymentInstruction from "../../Pages/dashboard/PaymentInstruction";
import { ArrowBack } from "@material-ui/icons";
import WaitForTransactionProcess from "./WaitForTransactionProcess";
import ErrorPayment from "./ErrorPayment";
import PaymentMethod from "./PaymentMethod";

export default class PricingKetengan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      package_selected: "personal",

      actived_tab: "license",
      page: "packages", // packages, payment, loading

      package_object: {},
      payment_id: "",
      error: {},
    };
  }
  async componentDidMount() {
    const payment = localStorage.getItem("payment");

    window.addEventListener("resize", this.updateMode);

    if (payment && payment !== "") {
      const body = {
        payment_type: "license_1",
        month: parseInt(payment), // ✅ Diberi key yang benar
        payment_methode: "midtrans",
      };

      let response = "";
      const current_url = window.location.href;
      if (current_url.includes("user_profile")) {
        response = await this.props.create_payment(body, "user_profile");
      } else {
        response = await this.props.create_payment(body);
      }

      if (response?.status === 200 && response?.id) {
        this.setState({ payment_id: response.id });
        this.set_page({ new_page: "payment" });
      } else {
        this.set_page({ new_page: "error" });
        this.set_error(response);
      }
    }
  }

  set_package_selected = (value) => {
    this.setState({
      package_selected: value,
    });
  };

  // on_set_month = (month) => {
  //   this.setState({ month });
  // };

  // on_set_collaborators = (collaborators) => {
  //   this.setState({ collaborators });
  // };

  toggleModalBuyNow = () => {
    this.setState({ modal_buy_now: !this.state.modal_buy_now });
  };

  set_page = ({ package_object, new_page }) => {
    const list_of_pages = [
      "packages",
      "payment_method",
      "payment",
      "loading",
      "error",
    ];
    const { page } = this.state;

    this.setState({
      page: list_of_pages.includes(new_page) ? new_page : page,
      package_object: package_object || this.state.package_object, // Tetap gunakan jika null
    });
  };

  handle_tab = (value) => {
    this.setState({
      actived_tab: value,
      modal_buy_now: false,
    });
  };

  set_payment_id = (value) => {
    this.setState({
      payment_id: value,
    });
  };

  set_error = (value) => {
    this.setState({
      error: value,
    });
  };

  render() {
    // local storage
    const language = localStorage?.language || "ina";

    // props
    const { is_redirect = false } = this.props

    // state
    const {
      month,
      actived_tab,
      package_selected,
      page,
      package_object,
      payment_id,
      error,
      // on_set_collaborators
    } = this.state;

    let content, title, description;
    if (actived_tab === "license") {
      if (page === "packages") {
        title = dict?.["Add ons for you"]?.[language];
        description =
          dict?.[
            "Get features at the best price on the market! Limited timeoffer to boost your productivity."
          ]?.[language];
        content = (
          <PaymentTableKetengan
            set_package_selected={this.set_package_selected}
            package_selected={package_selected}
            month={month}
            // on_set_month={this.on_set_month}
            // on_set_collaborators={this.on_set_collaborators}

            page={page}
            set_page={this.set_page}
          />
        );
      } else if (page === "payment_method") {
        title = "metode pembayaran"; //dict?.["Payment"]?.[language];
        // description = dict?.["Get features at the best price on the market! Limited timeoffer to boost your productivity."]?.[language]

        content = (
          <PaymentMethod
            set_page={this.set_page}
            month={month}
            set_payment_id={this.set_payment_id}
            package_object={package_object}
            set_error={this.set_error}
          />
        );
      } else if (page === "payment") {
        title = dict?.["Payment"]?.[language];
        // description = dict?.["Get features at the best price on the market! Limited time offer to boost your productivity."]?.[language]

        content = <PaymentInstruction is_redirect={is_redirect} payment_id={payment_id || ""} />;
      } else if (page === "loading") {
        title = dict?.["Please Wait..."]?.[language];
        content = <WaitForTransactionProcess />;
      } else if (page === "error") {
        title = dict?.["Error"]?.[language];
        content = <ErrorPayment error={error} />;
      }
    } else if (actived_tab === "redeem code") {
      title = "Redeem MAPID Code";
      description = dict?.["Enter your code to get discount."]?.[language];
      content = <RedeemButton />;
    }

    return (
      <main className="flex flex_col gap_30">
        <header className="flex justify_start gap_20">
          {page !== "packages" && (
            <div className="flex justify_start">
              <div
                onClick={() => {
                  if (
                    page === "payment_method" ||
                    page === "payment" ||
                    page === "error"
                  ) {
                    this.set_page({ new_page: "packages" });
                  }

                  // if (page === "bundle") {
                  //   this.set_page({ new_page: "packages" });
                  // } else if (page !== "packages" && actived_tab === "license") {
                  //   this.set_page({ new_page: "bundle" });
                  // } else if (page !== "packages" && actived_tab === "access") {
                  //   this.set_page({ new_page: "packages" });
                  // }
                }}
                className="pointer hover_bigger w_50 h_50 bg_darkBlue center_perfect text_white rounded_50"
              >
                <ArrowBack />
              </div>
            </div>
          )}

          <div>
            <label className="font_30 bold">{title}</label>
            <p>{description}</p>
          </div>
        </header>

        <footer style={{ minHeight: "300px" }}>{content}</footer>
      </main>
    );
  }
}
